<template>
    <body id="poster">

    <el-header style="    justify-content: space-between;margin: 32px 40px;position: relative;"><el-image src="
https://scriptmaster.darknight.games/ConfigNaoDong/6d926917-d9b7-4970-bbcd-4bfe8c93ecb0.png" style="width: 280px"></el-image>
<!--      <el-image src="https://scriptmaster.darknight.games/ConfigNaoDong/72f9353d-8cd2-4c7b-8461-01723f16e852.jpg" ></el-image>-->
    </el-header>
    <div class="account-sdk-wrap">
    <el-form class="login-container" label-position="left"
             label-width="0px">
        <div >
            <h2 class="account-center-header-title">登录幻视账号</h2>
        <el-form-item>
            <el-input class="ace-ui-input" type="text" v-model="loginForm.username"
                      auto-complete="off" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item>
            <el-input class="ace-ui-input ace-ui-input-group-filled" type="password" v-model="loginForm.password"
                      auto-complete="off" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item >
            <el-button  style="background:rgb(42, 85, 229);color: white;"  class="account-button" v-on:click="login">登录</el-button>
        </el-form-item>
        </div>
    </el-form>
    </div>
    </body>
</template>

<script>

    import axios from "axios";

    export default {
        name: 'Login',
        data () {
            return {
                loginForm: {
                    username: '',
                    password: ''
                },
                responseResult: []
            }
        },mounted(){


        },destroyed() {
            //取消键盘监听事件
            document.onkeydown = null
        },
        methods: {
            login () {
                var _this = this
                this.$axios.defaults.baseURL='https://dy.darknight.games/api'
              // this.$axios.defaults.baseURL = 'https://localhost:4444/api'
                this.$axios
                    .post('/login', {
                        username: this.loginForm.username,
                        password: this.loginForm.password
                    })
                    .then(successResponse => {
                        if (successResponse.data.state === 200) {
                          // 假设后端返回的用户名字段是 'username'
                          const returnedUsername = successResponse.data.username
                          const loginUser = Object.assign({}, successResponse.data, successResponse.data.user || successResponse.data.data || {}, {
                            username: returnedUsername || this.loginForm.username,
                            password: this.loginForm.password
                          })

                          // 将用户名存储到 Vuex store
                          _this.$store.commit('setUsername', loginUser.username)

                          _this.$store.commit('login', loginUser)
                            var path = this.$route.query.redirect
                            this.$router.replace({path: path === '/' || path === undefined ? '/HelloWorld' : path})

                            // this.$axios.defaults.baseURL='https://data.darknight.games/api'

                        }else {

                            this.$message.error('账号密码错误');

                            // this.$axios.defaults.baseURL='https://data.darknight.games/api'

                        }
                    })


            },
        }
    }
</script>
<style>
    #poster {
        background:url("https://lf3-static.bytednsdoc.com/obj/eden-cn/ylaulj_aubvjjh/ljhwZthlaukjlkulzlp/ad-no-slogan.jpg") no-repeat;
      background-position: 0;
      background-repeat: no-repeat;
      background-size: cover;
      min-height: 100vh;
      overflow: hidden;
      position: relative;
      width: 100%;
    }
    body{
        margin: 0px;
    }

    .account-button {
      width: 100%;
      font-weight: 500;
      font-size: 16px;
      border: none;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .account-sdk-wrap {

      position: absolute;
      right: 22%;
      top: 50%;
      transform: translateY(-50%);
    }


    .login-container {

      background: rgb(255, 255, 255);
      -webkit-box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
      box-shadow: 0 2px 8px rgb(0 0 0 / 8%);
      border-radius: 12px;
      position: relative;
      width: 360px;
      color: #444444;
      padding: 24px 32px;
      display: inline-block;
      z-index: 1;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }
    .login-container:hover{

        /*border: 1px solid #eaeaea;*/

    }
    .account-center-header .account-center-header-title {
       font-size: 20px;
       line-height: 24px;
       font-weight: 600;
       color: #333;
       margin-bottom: 8px;
       display: -webkit-box;
       display: -ms-flexbox;
       display: flex;
       -webkit-box-align: center;
       -ms-flex-align: center;
       align-items: center;
     }
    .ace-ui-input .ace-input {
      display: inline-block;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: 5px 12px;
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      list-style: none;
      background-color: #ffffff;
      background-image: none;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      outline: none;
    }
    .login_title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }

</style>
<style scoped>

/* 改变input框背景颜色 */
/deep/ .el-input__inner {
  background-color: rgba(240, 240, 240, 0.94);

}

</style>
